import { getCMSConfig } from '../cms';
import { JarvisPrice } from '../../interface';
import { Price } from '@vfde-brix/ws10/core';
import { JarvisPriceType } from '../../enum';
import { DeepPartial } from 'redux';
import { IOfferSummaryCardPromoPrice } from '@vfde-brix/ws10/offer-summary-card';

/**
 * Get the properties for the promo price component
 * @param {JarvisPrice} routerPrice - The price of the selected router
 * @returns {Partial<IPromoPriceProperties>} The properties to update on the promo price component
 */
export const getRouterPriceProps = (routerPrice: JarvisPrice): DeepPartial<IOfferSummaryCardPromoPrice> => {
    const { textAfterPrice } = getCMSConfig().offerSummaryCard;

    switch (routerPrice.type) {
        case JarvisPriceType.ONCE:
            return {
                containerPromoPrice: {
                    price: Price.fromNumber(routerPrice.value),
                },
                txtLabel: textAfterPrice.once,
            };
        case JarvisPriceType.MONTHLY:
            return {
                containerPromoPrice: {
                    price: Price.fromNumber(routerPrice.value),
                },
                txtLabel: textAfterPrice.monthly,
            };

        case JarvisPriceType.STAIRWAY:
            if (!routerPrice.stairway) {
                // Jarvis error
                return {};
            }

            return {
                containerPromoPrice: {
                    price: Price.fromNumber(routerPrice.stairway.value),
                },
                txtLabel: textAfterPrice.monthly,
            };
    }
};
